import { shallow } from "zustand/shallow";

import { generateLocalId } from "../store/helpers";
import useExplorerStore from "../store/store";
import useListingsData from "./useListingsData";
import useShareClasses from "./useShareClasses";

function useShowFundCard(fundId: string) {
    const { getFundById } = useExplorerStore(
        ({ getFundById }) => ({ getFundById }),
        shallow,
    );
    const fund = getFundById(fundId);
    const shareClasses = useShareClasses(
        fund!.data.share_classes.map(generateLocalId("shareclass")),
    );
    const listings = useListingsData(shareClasses.map((s) => s.localId));
    return fund?.type === "etf"
        ? shareClasses.length > 0 &&
              Object.values(listings).some((l) => l.length > 0)
        : shareClasses.length > 0;
}

export default useShowFundCard;
